import { makeLoader, normalizeForLoader } from '@lib/common';
import DataLoader from 'dataloader';
import { map } from 'rxjs/operators';
import * as gvdSourceDataService from '@api/holding-data';
import { ExpiryMap } from '@lib/common/expiry-map';
import { GvdSourceDataDetail } from '@lib/holding-data';

/**
 * NOTE: This is a dummy dataloader, as you can see it does not actually utilize the
 * dataloader paradim. This will be replaced with actual pint/deli APIs when have a
 * batch api to get the results.
 */
export const gvdSourceDataLoader = new DataLoader(
  (ids: string[]) =>
    gvdSourceDataService
      .gvdSourceDataFilter({
        filters: [
          {
            id: 'programContextId',
            value: {
              $in: ids.join(','),
            },
          },
        ],
        pageSize: ids.length > 10 ? ids.length : 10,
      })
      .pipe(
        map(res => res.data.data),
        normalizeForLoader(
          ids,
          cmp => cmp.programContextId,
          id => new Error(`No GVD Content with id ${id}`)
        )
      )
      .toPromise(),
  {
    cacheMap: new ExpiryMap(120),
    maxBatchSize: 15,
  }
  // { cacheMap: new ExpiryMap(60) }
);

export const useGvdSSourceDataLoader = makeLoader(gvdSourceDataLoader);
